import React from 'react'

export default class OnOffToggle extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { on, onClick } = this.props
        if (on) {
            return (
                <div className="on-off-toggle on" onClick={onClick}>
                    <div>
                        <i className="fa fa-check" aria-hidden="true"></i>
                    </div>
                    <div>
                        <i className="fa fa-square"></i>
                    </div>
                </div>
            )
        }

        return (
            <div className="on-off-toggle off" onClick={onClick}>
                <div>
                    <i className="fa fa-square off-state"></i>
                </div>
                <div>
                    <i className="fa fa-times off-state" aria-hidden="true"></i>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/on_off_toggle.jsx